import step1Schema from './general/step-1.general.schema'
import step2Schema from './general/step-2.id-document.schema'

import DefaultStep from '../steps/Step.Default'
import { i18n } from '@js/i18n'

export default [
  { name: 'step-1', done: false, component: DefaultStep, schema: step1Schema, label: i18n.kyc_personal_details() },
  { name: 'step-2', done: true, component: DefaultStep, schema: step2Schema, label: i18n.kyc_document_details() },
]



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/kyc-steps.general.schema.js